import styled, { css } from 'styled-components';
import breakpoints, { under } from 'styles/config/breakpoints';
import themeColors from 'styles/config/colors';
import themeSpacing from 'styles/config/spacing';
import text from 'styles/config/text';

export const ScreenHeaderWrapper = styled.header<{
  $backButton: boolean;
  $fullWidth: boolean;
}>`
  display: flex;
  flex-direction: row;
  margin-bottom: ${themeSpacing.sm3};

  @media ${under(breakpoints.sm)} {
    margin-bottom: ${themeSpacing.sm1};
  }

  ${({ $backButton }) =>
    $backButton &&
    css`
      a {
        display: flex;
        align-items: center;

        button {
          width: ${themeSpacing.md1};
          height: ${themeSpacing.md1};
          background-color: ${themeColors.backgroundPage};
        }
      }
    `}

  ${({ $fullWidth }) =>
    $fullWidth &&
    css`
      width: 100%;
    `}
`;

export const Content = styled.div`
  overflow: hidden;
  width: 100%;
`;

export const HeadlineWrapper = styled.div`
  flex: 0;
  line-height: 100%;
`;

export const TitleWrapper = styled.div`
  display: flex;
  align-items: flex-end;
`;

export const Description = styled.p`
  display: flex;

  /* width is hard-coded by design */
  width: 660px;
  max-width: 100%;
  height: unset;
  min-height: ${themeSpacing.sm3};
  margin-top: ${themeSpacing.sm1};

  font-size: ${text.size.body.regular};
  color: ${themeColors.textSecondary};

  @media ${under(breakpoints.sm)} {
    width: 100%;
  }
`;
